module.exports = __webpack_public_path__ + "media/images/lb/469-83d18491b5565eef7504e64fa5ba31b4.svg";